import { useCallback } from 'react';

import { useQueryClient } from '@tanstack/react-query';

export const useResetEmailTemplates = (): VoidFunction => {
  const queryClient = useQueryClient();

  const handleResetEmailTemplates = useCallback(() => {
    void queryClient.resetQueries({
      queryKey: ['emailTemplates'],
      exact: false,
    });
  }, [queryClient]);

  return handleResetEmailTemplates;
};
